// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/upload/style/index.less
// module id = 978
// module chunks = 1